export default __webpack_public_path__ + "static/media/fsk-23-a.059f1672.jpg";